import { useState, useEffect } from "react";
import { Building2, CheckCircle, AlertCircle, ArrowRight } from "lucide-react";
import { getBusinessDetails } from "../apis/businessDetails";
import BusinessDetailsModal from "./BusinessDetailsModal";

const BusinessDetailsStrip = () => {
  const [businessDetails, setBusinessDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadBusinessDetails();
  }, []);

  const loadBusinessDetails = async () => {
    try {
      setIsLoading(true);
      const response = await getBusinessDetails();
      if (response.data.success) {
        setBusinessDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error loading business details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyClick = () => {
    setShowModal(true);
  };

  const handleModalSuccess = () => {
    loadBusinessDetails();
  };

  if (isLoading) {
    return null;
  }

  // If business details are not added - Breaking News Style Strip
  if (!businessDetails?.profile_completed || !businessDetails?.legal_business_name) {
    return (
      <>
        <div className="w-full overflow-hidden mb-4">
          <div
            className="relative py-3 px-4 border-b-2 border-[#01CC54]"
            style={{ backgroundColor: "#e9eeea" }}
          >
            <div className="flex items-center gap-4 overflow-x-auto">
              <div className="flex items-center gap-2 px-3 py-1 bg-[#01CC54] text-white font-bold text-xs uppercase whitespace-nowrap rounded">
                <AlertCircle size={14} />
                Action Required
              </div>
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <span className="text-sm font-bold text-gray-900 whitespace-nowrap">
                  Verify Your Business Details
                </span>
                <span className="text-xs text-gray-600 hidden sm:inline">
                  • Complete your business profile to unlock all features
                </span>
              </div>
              <button
                onClick={handleVerifyClick}
                className="flex items-center gap-1 px-4 py-1.5 bg-[#01CC54] text-white rounded-lg font-bold text-xs hover:bg-[#01CC54]/90 transition-all whitespace-nowrap"
              >
                Verify Now
                <ArrowRight size={14} />
              </button>
            </div>
          </div>
        </div>

        <BusinessDetailsModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onSuccess={handleModalSuccess}
        />
      </>
    );
  }

  // If business details are added - Breaking News Style Strip
  return (
    <>
      <div className="w-full overflow-hidden mb-4">
        <div
          className="relative py-3 px-4 border-b-2 border-[#01CC54]"
          style={{ backgroundColor: "#e9eeea" }}
        >
          <div className="flex items-center gap-4 overflow-x-auto">
            <div className="flex items-center gap-2 px-3 py-1 bg-[#01CC54] text-white font-bold text-xs uppercase whitespace-nowrap rounded">
              <CheckCircle size={14} />
              Verified
            </div>
            <div className="flex items-center gap-3 flex-1 min-w-0 text-sm">
              <span className="font-bold text-gray-900 whitespace-nowrap">
                {businessDetails.legal_business_name}
              </span>
              {businessDetails.city && businessDetails.state && (
                <span className="text-gray-600 hidden md:inline whitespace-nowrap">
                  • {businessDetails.city}, {businessDetails.state}
                </span>
              )}
              {businessDetails.business_email && (
                <span className="text-gray-600 hidden lg:inline whitespace-nowrap">
                  • {businessDetails.business_email}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessDetailsStrip;

